import { GetterTree } from 'vuex'
import { ConfigurationInfoState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ConfigurationInfoState, RootState> = {}
